import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutreachEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 122,
	height: 51,
	viewBox: "0 0 122 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M113.5 0H47.5C42.5 0 39 0.998535 39.5 5.00008C40 9.00162 45.5 9.50008 41.5 9.50008H17.5C15.8333 9.50008 12.4 10.4001 12 14.0001C11.6 17.6001 14.5 20.0001 17.5 20.0001H33.5C39.5 20.0001 41.5 21.5001 41.5 26.0001C41.5 30.5001 33.5 30.0001 33.5 30.0001H8C3.5 30.0001 0 30.9985 0 35.4985C8.1477e-10 41.0001 6 40.4985 8 40.4985L33.5 41.0001C35.5 41.0001 27.5 40.9985 27.5 45.4985C27.5 49.9985 32 50.5001 35 50.4985C52.8333 50.4894 88.1 50.5001 92.5 50.5001C98.0081 50.5001 100 48.4985 100 45.4985C100 42.4985 96.5 41.0001 92.5 41.0001C88.5 41.0001 87 37.9985 87 35.4985C87 32.9985 89 30.0001 92.5 30.0001H101.5C106 30.0001 109 28.4985 109 24.9985C109 22.1985 105.5 19.9985 100 19.9985C93.8333 19.9985 91.5 20.0001 89.5 20.0001C86 20.0001 93.5 17.9985 93.5 14.4985C93.5 10.9985 88 9.50008 89.5 9.50008H113.5C117 9.50008 120.5 8.49869 120.5 5.00008C120.5 0.998465 116 -8.97166e-05 113.5 0Z",
			fill: "#E4E0FF",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 117,
			cy: 24.9985,
			r: 5,
			fill: "#E4E0FF",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46 43.9985C44 43.9985 44 42.4985 44 40.9985V14.9985C44 13.3985 44 12.4985 46 12.4985C58.5 12.3319 84.5 11.9985 86.5 11.9985C89 11.9985 89 12.4985 89 14.9985V40.9985C89 42.4985 89 43.9985 86.5 43.9985H46Z",
			fill: "white",
			fillOpacity: .85
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88 12L44.5 12.5C51.4619 17.1667 65.5171 26.5 66.5 26.5C67.4829 26.5 81.4476 16.6667 88 12Z",
			fill: "#F4F3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 12.9985C51.1667 17.4985 65.7 26.4985 66.5 26.4985C67.3 26.4985 81.5 17.1652 88.5 12.4985",
			stroke: "#28117F",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46 43.998C44 43.998 44 42.498 44 40.998V14.998C44 13.398 44 11.998 46 11.998H86.5C89 11.998 89 12.498 89 14.998V40.998C89 42.498 89 43.998 86.5 43.998H46Z",
			stroke: "#28117F",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93 16.4985H105",
			stroke: "#28117F",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108 16.4985H112",
			stroke: "#28117F",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95 20.4985H102",
			stroke: "#28117F",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 34.4985H39",
			stroke: "#28117F",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 34.4985H23",
			stroke: "#28117F",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 38.4985H36",
			stroke: "#28117F",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgOutreachEmpty;
